// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import {
    Item,
    Translate,
} from '@plesk/ui-library';
import {
    DashboardItemContainer,
    ItemAdditionalDescription,
} from 'admin/dashboard/containers/items/Styles';
import {
    convertToDataUnit,
    pickDataUnit,
    usagePercentage,
} from 'common/helpers/units';
import CardHeader from 'admin/dashboard/components/CardHeader';

export type ClusterMemoryItemProps =
    ReturnType<typeof mapStateToProps>;

export const ClusterMemoryItem: React.FC<ClusterMemoryItemProps> = ({
    stats,
}) => {
    const usage = usagePercentage(stats.total, stats.used);
    const unit = pickDataUnit(stats.total);
    const formattedTotal = convertToDataUnit(stats.total, unit);
    const formattedUsed = convertToDataUnit(stats.used, unit);

    return (
        <DashboardItemContainer>
            <Item
                description={(
                    <ItemAdditionalDescription>
                        <Translate
                            content="dashboard.cards.usage"
                            params={{
                                used: formattedUsed,
                                total: formattedTotal,
                                unit: unit.toString(),
                            }}
                        />
                    </ItemAdditionalDescription>
                )}
                view="card"
                title={
                    <CardHeader>
                        <Translate content="dashboard.cards.clusterMemory" params={{ usage }} />
                    </CardHeader>
                }
            />
        </DashboardItemContainer>
    );
};

const mapStateToProps = (state: RootState) => ({
    stats: state.dashboard.data.cluster_memory,
});

export default connect(mapStateToProps)(ClusterMemoryItem);
